export default __webpack_public_path__ + "static/media/cuppa.a7c7c7c5.png";